import { render } from "./patientWaitBackground.vue?vue&type=template&id=c49b58ea"
import script from "./patientWaitBackground.vue?vue&type=script&lang=js"
export * from "./patientWaitBackground.vue?vue&type=script&lang=js"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__